export const baseAccountApiUrl = '/1.0/public/account/external';
export const baseAccountPublicApiUrl = '/1.0/public/accounts/public';
export const baseCartApiUrl = '/1.0/public/cart/external';
export const baseCCApiUrl = '/1.0/public/creditCard';
export const baseOrderApiUrl = '/1.0/public/order/external';
export const baseOrderCartApiUrl = '/1.0/public/order/cart';
export const baseOrdersContactApiUrl = '/1.0/public/orders/contact';
export const baseOrderQuoteApiUrl = '/1.0/public/order/quote';
export const baseOrderNonExternalApiUrl = '/1.0/public/order';
export const baseRefundApiUrl = '/1.0/public/refund/external';
export const baseContactApiUrl = '/1.0/public/contact/external';
export const baseLicenseApiUrl = '/1.0/public/license/external';
export const baseConsentHubApiUrl = '/1.0/public/consenthub';
export const baseGenericPropertyApiUrl = '/1.0/public/genericProperty';
export const baseDownloadsApiUrl = '/1.0/public/downloads';
export const baseCurrencyApiUrl = '/1.0/public/currency';
export const baseNonExternalContactApiUrl = '/1.0/public/contact';
export const baseProductApiUrl = '/1.0/public/product';
export const baseCountryApiUrl = '/1.0/public/country';
export const baseMarketplaceApiUrl = '/1.0/public/vendor';
export const baseNoteAccountApiUrl = '/1.0/public/note/account';
export const basePartnerMigrationApiUrl = '/1.0/public/migration/partner';
export const baseCloudApiUrl = '/1.0/private/cloud';
export const baseNonExternalAccountApiUrl = '/1.0/public/account';
